
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const stereoComp33609: IProductData = {
  id: "neve-33609-stereo-comp",
  name: "33609/N Stereo Limiter/ Compressor",
  description: "This desert island stereo compressor offers comprehensive limiting and compression facilities ideal for music recording, mastering, post-production and broadcast applications.",
  specialOrder: true,
  images: ["/img/neve_33609_front.jpg", "/img/neve_33609_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
The 33609/N uses exclusive Marinair® specification transformers on the input, bridge-driver, sidechain and output stages – Neve® colour throughout.  
The independent compressor and limiter circuitry gives ultimate dynamic control over transients.  
With the limiter input positioned after the compressors make up gain, the 33609 can be used as a creative tool with the limiter driven by the compressor’s output.  
  
The 33609’s feedback-style compression feeds the compressors control signals back through the diode-bridge gain reduction circuit.  
This design introduces analogue non-linearities that form the unique character of  33609/N.  
`
    }, {
      label: "Specifications",
      markdown: `
• Legendary dual channel diode-bridge compressor/limiter
• Discrete class-A design offers fast and slow attack times, multiple release times and threshold levels
• Optional link to other units for multi-channel use
• Hand-crafted by Neve in Burnley, UK
`
  }, {
    label: "Audio Performance",
    markdown: `
• Input: Input Impedance 10kΩ (internally switchable to 600Ω , refer to vendor)
• Output: Maximum output >26dBu into 600Ω, balanced and earth free
• Distortion: <0.075% at 1kHz (bypass in, compress and limit out, input level 9dBu); <0.2% at 1kHz (compress in, ratio 6:1, gain 20dB, recovery 800mS, threshold −18dBu); <0.45% at 1kHz (limit in, compress out, recovery 800mS, input level 22dBu, threshold −18dBu)
• Frequency Response: ±0.5dB 20Hz to 20kHz rel. 1kHz
• Noise: −75dBu, 22Hz – 22kHz, input terminated with 600Ω (bypass in, compress and limit out), −55dBu (compress in, gain 20dB)
• Limit Threshold: 4dBu to 15dBu
• Limit Ratio: Change in output level <0.1dB with 10dBu to 20dBu step input
• Limit Attack Time: Fast 2ms ±1, slow 4ms ±1
• Limit Recovery Time: 50ms to 800ms, a1 (auto): 100ms/2000ms, a2 (auto): 50ms/5000ms
• Compress Ratio: 1.5:1 to 6:1
• Compress Attack Time: Fast 3ms ±1, slow 6ms ±1 with 100Hz first order high-pass filter
• Compress Recovery Time: 100ms to 1500ms, a1 (auto): 100ms/2000ms, a2 (auto): 50ms/5000ms
`
  }, {
    label: "Dimensions",
    markdown: `
• Width: 482mm (19 inches)
• Height: 90mm (3.5 inches) (2U)
• Depth: 254mm (10 inches)
• Weight: 5kg (11 pounds)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/limiter-compressors/33609-stereo-compressor" target="_blank">https://www.ams-neve.com/outboard/limiter-compressors/33609-stereo-compressor</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.LIMITER, HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.MASTERING, HASHTAGS.TWO_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}